import React, {useState} from "react";

const PrintScreenButton = ({downloadUrl,exercise_id,audiourl,px_class}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const handleDownload = () => {
    setIsDownloading(true);
    if(exercise_id && audiourl)  {
      handleButtonClick();
    }
    setTimeout(() => {
      setIsDownloading(false);
    }, 2000);
  };
  const handleButtonClick = async () => {
    try {
      // Fetch the audio file
      const response = await fetch(audiourl);
      const blob = await response.blob();
      // Create a download link
      const url = window.URL.createObjectURL(blob);
      console.log(blob,url);
      const link = document.createElement('a');
      link.href = url;
      link.download = `audio-${exercise_id}.mp3`; // Set the desired file name
      document.body.appendChild(link);
      
      // Trigger the download
      link.click();

      // Remove the link from the DOM
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading audio file:', error);
    }
  };

  return (
    <a href={`${downloadUrl}`} onClick={handleDownload} class={isDownloading ? `disabled_btn btn fw-bold btpy-2 btn-lg fs-8 ${px_class} rounded-5` : `btn btn-lg fs-8 fw-bold ${px_class} btpy-2 rounded-5`}
    style={{ borderColor: "#2E58D4", color: "#2E58D4", backgroundColor: "rgba(46, 88, 212, 0.06)",}} type="button">
      <svg width="20" height="20" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_9534_7850)">
        <path d="M13.9729 6.31721V4.88589C13.9729 3.9952 13.9729 3.54986 13.8037 3.20966C13.6549 2.91042 13.4174 2.66712 13.1253 2.51465C12.7931 2.34131 12.3584 2.34131 11.4889 2.34131H7.14183C6.27233 2.34131 5.83758 2.34131 5.50548 2.51465C5.21335 2.66712 4.97585 2.91042 4.827 3.20966C4.65779 3.54986 4.65779 3.9952 4.65779 4.88589V6.31721M4.65779 15.0642C3.93588 15.0642 3.57493 15.0642 3.27879 14.9829C2.47514 14.7623 1.84742 14.1193 1.63209 13.2961C1.55273 12.9927 1.55273 12.623 1.55273 11.8835V10.1341C1.55273 8.79805 1.55273 8.13004 1.80656 7.61974C2.02983 7.17087 2.38609 6.80593 2.82428 6.57722C3.32243 6.31721 3.97455 6.31721 5.2788 6.31721H13.3519C14.6562 6.31721 15.3083 6.31721 15.8065 6.57722C16.2446 6.80593 16.6009 7.17087 16.8242 7.61974C17.078 8.13004 17.078 8.79805 17.078 10.1341V11.8835C17.078 12.623 17.078 12.9927 16.9986 13.2961C16.7833 14.1193 16.1556 14.7623 15.3519 14.9829C15.0558 15.0642 14.6948 15.0642 13.9729 15.0642M11.6442 9.10035H13.9729M7.14183 18.2449H11.4889C12.3584 18.2449 12.7931 18.2449 13.1253 18.0716C13.4174 17.9191 13.6549 17.6758 13.8037 17.3766C13.9729 17.0364 13.9729 16.591 13.9729 15.7003V14.4281C13.9729 13.5374 13.9729 13.092 13.8037 12.7518C13.6549 12.4526 13.4174 12.2093 13.1253 12.0568C12.7931 11.8835 12.3584 11.8835 11.4889 11.8835H7.14183C6.27233 11.8835 5.83758 11.8835 5.50548 12.0568C5.21335 12.2093 4.97585 12.4526 4.827 12.7518C4.65779 13.092 4.65779 13.5374 4.65779 14.4281V15.7003C4.65779 16.591 4.65779 17.0364 4.827 17.3766C4.97585 17.6758 5.21335 17.9191 5.50548 18.0716C5.83758 18.2449 6.27233 18.2449 7.14183 18.2449Z" stroke="#2E58D4" stroke-width="1.55253" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_9534_7850">
        <rect width="18.6303" height="19.0843" fill="white" transform="translate(0 0.750977)"/>
        </clipPath>
        </defs>
      </svg>
      <span className="ps-1">Print task</span>
    </a>
  )
};

export default PrintScreenButton;